import {loadSubscription} from '@/modules/ProjectModule/modules/api/subscription.api';

function initialState() {
    return {
        subscription: null,
    }
}

const getters = {
    subscription: (state) => state.subscription,
    isTrial:      (state, getters) => getters.subscription ? getters.subscription.type === 'trial' : false,
}

const actions = {
    async loadSubscription({ commit, rootGetters }) {
        const projectId = rootGetters['projects/project/projectId'];
        return loadSubscription(projectId).then((data) => commit('SET_SUBSCRIPTION', data));
    },

    reset: ({ commit }) => commit('RESET'),
}

const mutations = {
    SET_SUBSCRIPTION: (state, data) => state.subscription = data,
    RESET:            (state) => {
        const s = initialState();
        Object.keys(s).forEach(key => state[key] = s[key]);
    }
}

export default {
    namespaced: true,
    state:      initialState,
    getters,
    actions,
    mutations
}
